import "core-js/modules/es.array.push.js";
import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4a0919d8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "no-redirect"
};
const _hoisted_2 = ["onClick"];
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default {
  __name: 'index',
  setup(__props) {
    _useCssVars(_ctx => ({
      "227f6bee": linkHoverColor.value
    }));
    const route = useRoute();
    // 生成数组数据
    const breadcrumbData = ref([]);
    const getBreadcrumbData = () => {
      breadcrumbData.value = route.matched.filter(item => item.meta && item.meta.title);
    };
    // 监听路由变化时触发
    watch(route, () => {
      getBreadcrumbData();
    }, {
      immediate: true
    });

    // 处理点击事件
    const router = useRouter();
    const onLinkClick = item => {
      router.push(item.path);
    };

    // 将来需要进行主题替换，所以这里获取下动态样式
    const store = useStore();
    // eslint-disable-next-line
    const linkHoverColor = ref(store.getters.cssVar.menuBg);
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      return _openBlock(), _createBlock(_component_el_breadcrumb, {
        class: "breadcrumb",
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_TransitionGroup, {
          name: "breadcrumb"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbData.value, (item, index) => {
            return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
              key: item.path
            }, {
              default: _withCtx(() => [index === breadcrumbData.value.length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.meta.title), 1)) : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "redirect",
                onClick: _withModifiers($event => onLinkClick(item), ["prevent"])
              }, _toDisplayString(item.meta.title), 9, _hoisted_2))]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};